import React from "react";
import { Box } from "@mui/material";

const labelFor = (confidence) => {
  const v = String(confidence || "").toLowerCase();
  if (v === "high") return "HIGH PRICE CONFIDENCE";
  if (v === "medium") return "MED PRICE CONFIDENCE";
  if (v === "low") return "LOW PRICE CONFIDENCE";
  return "";
};

const colorFor = (confidence) => {
  const v = String(confidence || "").toLowerCase();
  if (v === "high") return { bg: "#10B981", fg: "#FFFFFF" };
  if (v === "medium") return { bg: "#F59E0B", fg: "#FFFFFF" };
  if (v === "low") return { bg: "#6B7280", fg: "#FFFFFF" };
  return null;
};

const PriceConfidenceRibbon = ({ confidence }) => {
  const label = labelFor(confidence);
  const colors = colorFor(confidence);
  if (!label || !colors) return null;

  return (
    <Box
      sx={{
        backgroundColor: colors.bg,
        color: colors.fg,
        px: "8px",
        py: "4px",
        display: "inline-flex",
        alignItems: "center",
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.3px",
        borderRadius: "6px",
        width: "fit-content",
        lineHeight: 1,
      }}
    >
      {label}
    </Box>
  );
};

export default PriceConfidenceRibbon;
